import {ScaleLinear} from 'd3-scale'
import {max, min} from './agg'
import {clamp} from 'remeda'

export namespace Rnge {
  /**A list of numbers from `start` (inclusive) to `end` (exclusive). incrementing by step (default 1) */
  export const createSteps = (range: [number, number], step?: number) => {
    const [start, end] = range
    step = step ?? (start >= end ? -1 : 1)
    let i = start
    const res = []
    while (i < end) {
      res.push(i)
      i += step
    }
    return res
  }

  /** a list `items` numbers evenly distributed numbers between start (inclusive) and end (inclusive) */
  export const create = ([start, end]: [number, number], items: number) => {
    const increment = (end - start) / (items - 1)
    return createSteps([0, items]).map(i => start + i * increment)
  }

  export const boundsOf = <T>(items: T[], by?: () => number): [number, number] => {
    const numbers = by ? items.map(by) : (items as number[])
    return [min(numbers), max(numbers)]
  }

  /** point v in within range (inclusive unless specified otherwise in the options) */
  export const between = (v: number, range: [number, number], options?: {exclusive?: boolean}) =>
    options?.exclusive ? v > range?.[0] && v < range?.[1] : v >= range?.[0] && v <= range?.[1]

  export const middleOf = ([start, end]: [number, number] | number[]) => start + (end - start) / 2

  export const width = ([start, end]: [number, number] | number[]) => Math.abs(end - start)

  export const clampRange = ([start, end]: [number, number] | number[], clampRange: {min?: number; max?: number}) => [
    clamp(start, clampRange),
    clamp(end, clampRange)
  ]

  export const isDefined = ([start, end]: [number, number] | number[]) => start != null && end != null

  export const isAscending = ([start, end]: [number, number] | number[]) => end != null && start != null && end > start

  export const scaleToObj = (scale: ScaleLinear<number, number, never>) => ({
    domain: scale.domain() as [number, number],
    range: scale.range() as [number, number]
  })

  export const scaleToString = (scale: ScaleLinear<number, number, never>) =>
    `${scale.domain().join('-')}|${scale.range().join('-')}`
}
